export default __webpack_public_path__ + "static/media/icons_customer_trust.3592cd5b.svg";